<template>
  <div class="chat-container w-100 position-relative bg-white">
    <div class="w-100 px-4 bg-green pb-4 mb-4">
      <div class="w-100">
        <div class="row no-gutters pt-4 pb-3 m-0">
          <div class="col-1 align-self-center">
            <router-link :to="`/${getMerchant.code}/concierge/room-dining`" class="d-inline-grid">
              <img src="../../../../assets/img/icon/back-white.svg" class="mt-1" width="18">
            </router-link>
          </div>
          <div class="col-11 align-self-center">
            <p class="mb-0 ml-2-back body-1-2 text-truncate text-white">Search foods & beverage</p>
          </div>
        </div>
        <div class="w-100">
          <div class="w-100 position-relative">
            <input 
              type="text" 
              class="body-2-2 pl-5 pr-5 w-100 border-green radius-12 bg-white" 
              style="padding-top:12px;padding-bottom:12px;"
              placeholder="What do you want to eat today?"
              @input="searchMenu"
              v-model="search">
            <img src="../../../../assets/img/icon/search.png" height="14" class="position-absolute" style="left:20px;top:15px;">
            <img v-if="search != ''" @click="clearSearch()" src="../../../../assets/img/icon/close.png" height="14" class="position-absolute cursor-pointer" style="right:20px;top:15px;">
          </div>
        </div>
      </div>
    </div>
    <div class="w-100 px-4">
      <div v-if="is_load" class="w-100 py-4 text-center">
        <loader />
      </div>
      <template v-else>
        <ErrorMessage v-if="error != ''" :message="error" />
        <template v-else>
          <div class="mb-4">
            <div class="w-100 no-ws mb-3 position-relative">
              <p class="mb-0 sub-heading-1-1">Category</p>
              <p v-if="category.selected != null" class="overline mb-0 position-absolute cursor-pointer" style="top: 6px; right:0px;" @click="selectCategory()">Clear</p>
            </div>
            <div class="w-100 no-ws">
              <div 
                v-for="cat in category.list" 
                class="d-inline-block align-middle mr-2 border-green radius-6 py-1 px-2 body-3 mb-2 text-green cursor-pointer" 
                :class="{
                  'bg-green text-white': category.selected != null && category.selected.id == cat.id 
                }"
                @click="selectCategory(cat)">
                {{cat.name}}
              </div>
            </div>
          </div>
          <div class="mb-4" v-if="search != '' || category.selected != null">
            <!-- <p class="mb-3 sub-heading-1-1" v-if="all_menu.length > 0">Search result</p> -->
            <div class="w-100 py-5 text-center" v-if="all_menu.length == 0">
              <img src="../../../../assets/img/icon/404.png" height="170" class="mb-3">
              <div class="w-80 mx-auto">
                <p class="body-1-2 mb-2">"{{search}}"</p>
                <p class="body-2-2 mb-0">The menu you are looking for can't be found</p>
              </div>
            </div>
            <template v-else>
              <div class="w-100" v-for="category_product in all_menu">
                <div class="mb-3">
                  <p class="mb-0 sub-heading-1-1">{{category_product.name}}</p>
                  <p class="mb-0 body-2-2-1">{{category_product.description}}</p>
                </div>
                <div class="row slim-grid-row">
                  <div class="col-6 mb-4" v-for="product_per_category in category_product.product">
                    <MenuFoodSquare :data="product_per_category" :general_data="general_data"></MenuFoodSquare>
                  </div>
                </div>
              </div>
            </template>
          </div>
          <div v-else class="mb-2">
            <p class="mb-2 sub-heading-1-1">Best Menu</p>
            <div class="row slim-grid-row">
              <div class="col-6 mb-4" v-for="bm in best_menu">
                <MenuFoodSquare :data="bm" :general_data="general_data"></MenuFoodSquare>
              </div>
            </div>
          </div>
        </template>
      </template>
    </div>
   
    <!-- Pop Up Cart -->
    <cartPopup :full_bottom="true"></cartPopup>
    <div class="height-63px" v-if="getConciergeOrder.cart.length > 0"></div>
  </div>
</template>
<script>
  import {mapGetters} from 'vuex';
  import {get} from '@/services/index.js';
  import MenuFoodSquare from '@/components/hotel/concierge/general/MenuFoodSquare'
  import cartPopup from '@/components/hotel/concierge/general/cartPopup'
  import BottomNavbar from '@/components/hotel/BottomNavbar';

  export default{
    components:{
      MenuFoodSquare,
      cartPopup,
      BottomNavbar
    },
    data(){
      return{
        is_load: true,
        error: '',
        category:{
          list: [],
          selected: null
        },
        best_menu: [],
        search: '',
        is_typing: null,
        all_menu: [],
        general_data: {}
      }
    },
    computed:{
      ...mapGetters(['getMerchant','getMetaTitleTemplate','getConciergeOrder']),
    },
    mounted(){
      this.loadFirstData()
    },
    methods:{
      clearSearch(){
        this.search = ''
        this.searchMenu()
      },
      selectCategory(data=null){
        this.category.selected = data
        this.searchMenu()
      },
      searchMenu(){
        if (this.is_typing != null) {
          clearTimeout(this.is_typing)
        }
        this.is_load = true
        let self = this
        this.is_typing = setTimeout(() => {
          self.loadSearchedMenu()
        }, 1000)
      },
      loadFirstData(){
        this.is_load = true
        this.error = ''
        this.loadGeneralSetting().then(()=>{
          this.loadProductCategory().then(()=>{
            this.loadBestMenu().then(()=>{
              this.is_load = false
            })
          })
        })
      },
      loadGeneralSetting(){
        return new Promise(done=>{
          this.general_data = {}
          get("CONCIERGE","room-dining/general",{
            merchant_id: this.getMerchant.id
          }).then(response=>{
            let res = response.data
            if(res.success) this.general_data = res.data
            else this.error = res.message
            done()
          })
        })
      },
      loadProductCategory(){
        return new Promise(done=>{
          this.category.list = []
          get("CONCIERGE", "room-dining/category-option",{
            merchant_id: this.getMerchant.id
          }).then(response=>{
            let res = response.data
            if(res.success){
              this.category.list = res.data
            }else{
              this.error = res.message
            }
            done()
          })
        })
      },
      loadBestMenu(){
        return new Promise(done=>{
          this.best_menu = []
          get("CONCIERGE", "room-dining/product-best",{
            merchant_id: this.getMerchant.id
          }).then(response=>{
            let res = response.data
            if(res.success){
              this.best_menu = res.data
            }else{
              this.error = res.message
            }
            done()
          })
        })
      },
      loadSearchedMenu(){
        this.is_load = true
        this.all_menu = []
        this.error = ''
        get("CONCIERGE", "room-dining/product",{
          merchant_id: this.getMerchant.id,
          keyword: this.search,
          category_id: this.category.selected == null ? '' : this.category.selected.id
        }).then(response=>{
          let res = response.data
          if(res.success){
            this.all_menu = res.data
          }else{
            this.error = res.message
          }
          this.is_load = false
        })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/hotel/concierge/roomdining/RoomDiningSearch.vue